// removed by extract-text-webpack-plugin
module.exports = {"container":"custom-tab__container___2F6-u","filters-container":"custom-tab__filters-container___2rptP","active":"custom-tab__active___1i5gK"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/custom-tab.scss
// module id = 1321
// module chunks = 0